import { render, staticRenderFns } from "./ChatFocusView.vue?vue&type=template&id=7f0a49e2&scoped=true"
import script from "./ChatFocusView.vue?vue&type=script&lang=js"
export * from "./ChatFocusView.vue?vue&type=script&lang=js"
import style0 from "./ChatFocusView.vue?vue&type=style&index=0&id=7f0a49e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0a49e2",
  null
  
)

export default component.exports